import { render } from "./Stammdaten.vue?vue&type=template&id=502d6e52"
import script from "./Stammdaten.vue?vue&type=script&language=ts&lang=js"
export * from "./Stammdaten.vue?vue&type=script&language=ts&lang=js"
script.render = render

export default script